﻿(function (document) {
  document.addEventListener("DOMContentLoaded", function () {
    var openModals = document.querySelectorAll('[data-display-on-load="true"]');
    if (openModals.length > 0) {
      document.querySelector('body').classList.add('newsletter-modal__overlayWrapper');
      openModals.forEach(function (modal) {
        modal.classList.add('open');
        setCloseButton(modal);
      });
    }

    var openOnExitModals = document.querySelectorAll('[data-display-on-exit="true"]');
    if (openOnExitModals.length > 0) {
      openOnExitModals.forEach(function (modal) {

        setCloseButton(modal);
        var mouseOutHandler = function (event) {
          onMouseOut(modal, event, mouseOutHandler);
        };

        document.addEventListener("mouseleave", mouseOutHandler);
      });
    }
  });

  function setCloseButton(modal) {
    modal.querySelectorAll('a[href="#close"]').forEach(function (element) {
      element.addEventListener('click', function (e) {
        e.preventDefault();
        modal.classList.remove('open');
        setClosedCookie(modal);
        document.querySelector('body').classList.remove('newsletter-modal__overlayWrapper');
      });
    });
  }

  function setClosedCookie(modal) {
    var days = 1;
    if (typeof modal.dataset.onPopupCloseDuration !== 'undefined') {
      days = parseInt(modal.dataset.onPopupCloseDuration);
    }
    var date = new Date();
    date.setDate(date.getDate() + days);
    var expires = ": expires =" + date.toUTCString();
    document.cookie = 'NewsletterClosedCookie=true' + expires + "; path=/";
  }

  function onMouseOut(modal, event, mouseOutHandler) {
    if (event.clientY < 50 && event.relatedTarget == null && !cookieExistsByName("NewsletterClosedCookie")) {
      document.querySelector('body').classList.add('newsletter-modal__overlayWrapper');
      modal.classList.add('open');
      document.removeEventListener("mouseleave", mouseOutHandler);
    }
  }

  function cookieExistsByName(name) {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      var cookieElements = cookies[i].split("=");
      if (name == cookieElements[0].trim()) {
        return true;
      }
    }

    return false;
  }

})(document);